import { giphyLightGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import { Button as ButtonComponent, NumberInput } from 'ui'

export const Button = styled(ButtonComponent)`
    color: ${giphyLightGrey};
    flex-shrink: 0;
`

export const Container = styled.div`
    display: flex;
`

export const EndTime = styled(NumberInput)`
    margin-left: auto;
    width: 100px;
`

export const StartTime = styled(NumberInput)`
    margin-right: auto;
    width: 100px;
`
